// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  Icon,
  CircularProgress,
  // LinearProgress,
  Backdrop,
  Table,
  // TableHead,
  TableContainer,
  TableCell,
  TableBody,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  // Stack,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import DataTable from "theme/Tables/DataTable";
import MDButton from "theme/components/MDButton";
import MDBadge from "theme/components/MDBadge";
import usePageTitle from "app/pageTitle";

function P2POrder() {
  const pageTitle = "View Order";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const { reference } = useParams();

  const [refreshPage, setRefreshPage] = useState(false);
  const [refreshStarted, setRefreshStarted] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [openCancelDialog, setCancelDialog] = useState(false);

  const [order, setOrder] = useState(null);
  const [orderswaps, setSwaps] = useState([]);

  function formatAmount(amount, currency) {
    const formatter = new Intl.NumberFormat(currency, {
      style: "currency",
      currency: `${currency}`,

      // These options are needed to round to whole numbers if that's what you want.
      // minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
    });

    return formatter.format(amount / 100);
  }

  function percentageFilled(amount, liquidity) {
    return (((amount - liquidity) / amount) * 100).toFixed(2);
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`p2p/user/orders/${reference}/get.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setOrder(result.data.data.order);
            setSwaps(result.data.data.order.transactions);
            if (result.data.data.order.closed === false) {
              if (refreshStarted !== null) {
                clearInterval(refreshStarted);
              }
              const id = setInterval(() => setRefreshPage(!refreshPage), 30000);
              setRefreshStarted(id);
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Make sure you have an active internet connection.");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function cancelOrder() {
    setShowLoading(true);
    await axios
      .post("p2p/user/orders/cancel.json", { reference: `${reference}` })
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred. Make sure you have an active internet connection.");
        setOpen(true);
      });
  }

  function getStatusColor(stat) {
    let statusColor = "warning";
    if (stat.toUpperCase() === "COMPLETED") {
      statusColor = "success";
    } else if (stat.toUpperCase() === "CANCELLED") {
      statusColor = "text";
    } else if (stat.toUpperCase() === "ERROR") {
      statusColor = "error";
    } else if (stat.toUpperCase() === "FAILED") {
      statusColor = "error";
    } else {
      statusColor = "warning";
    }

    return statusColor;
  }

  function swapState(theOrder) {
    if (theOrder === null) {
      return (
        <MDBox p={3} sx={{ textAlign: "center" }}>
          <Icon>list</Icon>
          <br />
          <MDTypography>Peer swaps will appear here...</MDTypography>
        </MDBox>
      );
    }

    if (
      theOrder.closed === false &&
      (theOrder.status === "active" || theOrder.status === "partial-fill")
    ) {
      return (
        <MDBox p={3} sx={{ textAlign: "center" }}>
          <CircularProgress color="info" />
          <MDTypography color="dark">Searching for peers...</MDTypography>
        </MDBox>
      );
    }
    return (
      <MDBox p={3} sx={{ textAlign: "center" }}>
        <Icon>list</Icon>
        <br />
        <MDTypography>No swaps found</MDTypography>
      </MDBox>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openCancelDialog}>
        <DialogTitle>
          <MDBox>Cancel Order?</MDBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox>Are you sure you want to cancel this order?</MDBox>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setCancelDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            No
          </MDButton>
          <MDButton
            color="warning"
            variant="outlined"
            onClick={() => {
              setCancelDialog(false);
              cancelOrder();
            }}
          >
            Yes
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox sx={{ marginBottom: "40px" }}>
                  <MDBox display="flex" alignItems="center" justifyContent="space-between">
                    <MDBox>
                      <MDButton
                        variant="text"
                        color="dark"
                        onClick={() => {
                          navigate("/p2p/fx");
                        }}
                      >
                        P2P Orders
                      </MDButton>
                    </MDBox>
                    <MDBox>
                      {/* <MDButton
                        variant="text"
                        color="dark"
                        sx={{ marginRight: "5px" }}
                        onClick={() => {
                          navigate("/p2p/orders/post");
                        }}
                      >
                        <Icon>add</Icon>&nbsp; Post Order
                      </MDButton> */}
                      <MDButton
                        variant="text"
                        color="dark"
                        onClick={() => {
                          navigate("/p2p/fx/my-orders");
                        }}
                      >
                        My Orders
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={0}>
                      <MDBox p={3} display="flex" justifyContent="space-between" mb={1}>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          P2P Order
                        </MDTypography>
                        {order !== null ? (
                          <MDBadge
                            badgeContent={order.status}
                            variant="contained"
                            container
                            color={getStatusColor(order.status)}
                          />
                        ) : (
                          <MDBadge badgeContent="---" variant="contained" container color="dark" />
                        )}
                      </MDBox>
                      <MDBox sx={{ textAlign: "center" }} pr={3} mb={5}>
                        {order === null ? (
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            ---
                          </MDTypography>
                        ) : (
                          <MDTypography variant="h6" fontWeight="light">
                            {order.status_message}
                          </MDTypography>
                        )}
                      </MDBox>
                      <MDBox mt={1}>
                        <TableContainer component={Paper}>
                          <Table aria-label="simple table">
                            {order === null ? (
                              <TableBody>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    No data
                                  </TableCell>
                                  <TableCell align="right">received</TableCell>
                                </TableRow>
                              </TableBody>
                            ) : (
                              <TableBody>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Reference
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {order.reference}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Currency Pair
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="button" fontWeight="medium" ml={1}>
                                      {order.side === "BUY"
                                        ? `${order.currency_pair.slice(
                                            -3
                                          )} to ${order.currency_pair.slice(0, 3)}`
                                        : `${order.currency_pair.slice(
                                            0,
                                            3
                                          )} to ${order.currency_pair.slice(-3)}`}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Order Side
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDBadge
                                      badgeContent={order.side}
                                      variant="contained"
                                      container
                                      color={order.side === "SELL" ? "error" : "success"}
                                    />
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Order Type
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDBox
                                      variant="text"
                                      color={order.type === "LIMIT" ? "warning" : "info"}
                                    >
                                      <Icon>money</Icon>&nbsp;
                                      {order.type === "LIMIT" ? "FIXED" : "MARKET"}
                                    </MDBox>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Order Amount
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {formatAmount(order.amount, order.currency_pair.slice(0, 3))}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                {order.type === "LIMIT" ? (
                                  <TableRow
                                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                  >
                                    <TableCell component="th" scope="row">
                                      <MDTypography variant="h6" fontWeight="light">
                                        Exchange Rate
                                      </MDTypography>
                                    </TableCell>
                                    <TableCell align="right">
                                      <MDTypography variant="h6" fontWeight="medium">
                                        {formatAmount(
                                          order.side === "BUY"
                                            ? order.limit_buy_rate
                                            : order.limit_sell_rate,
                                          order.currency_pair.slice(-3)
                                        )}
                                      </MDTypography>
                                    </TableCell>
                                  </TableRow>
                                ) : (
                                  <> </>
                                )}
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Filled
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {percentageFilled(order.amount, order.liquidity)}%
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Status
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {order.closed ? "Closed" : "Open"}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Status Message
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {order.status_message}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Posted On
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {order.created}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                {order.closed ? (
                                  <> </>
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={2}>
                                      <MDBox sx={{ textAlign: "center" }} p={2}>
                                        <MDButton
                                          variant="outlined"
                                          color="warning"
                                          onClick={() => {
                                            setCancelDialog(true);
                                          }}
                                        >
                                          <Icon>close</Icon>&nbsp; Cancel Order
                                        </MDButton>
                                      </MDBox>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            )}
                          </Table>
                        </TableContainer>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                        Peer Swaps
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={-1}>
                      {orderswaps.length <= 0 ? (
                        swapState(order)
                      ) : (
                        <TableContainer>
                          <Table mb={5}>
                            <TableBody>
                              {orderswaps.map((transaction) => (
                                <TableRow key={transaction.reference}>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    <MDTypography variant="h6">Amount</MDTypography>
                                    <MDTypography variant="h6" fontWeight="light">
                                      {formatAmount(
                                        transaction.base_amount,
                                        order.currency_pair.slice(0, 3)
                                      )}
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "center" }}>
                                    <MDTypography variant="h6">Ex. Rate</MDTypography>
                                    <MDTypography variant="h6" fontWeight="light">
                                      {formatAmount(
                                        order.side === "BUY"
                                          ? transaction.buy_exchange_rate
                                          : transaction.sell_exchange_rate,
                                        order.currency_pair.slice(-3)
                                      )}
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "center" }}>
                                    <MDTypography variant="h6">
                                      You {order.side === "BUY" ? "paid" : "received"}
                                    </MDTypography>
                                    <MDTypography variant="h6" fontWeight="light">
                                      {formatAmount(
                                        order.side === "BUY"
                                          ? transaction.quote_debit_amount
                                          : transaction.quote_credit_amount,
                                        order.side === "BUY"
                                          ? order.currency_pair.slice(-3)
                                          : order.currency_pair.slice(-3)
                                      )}
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "right" }}>
                                    <MDTypography variant="h6">Date</MDTypography>
                                    <MDTypography variant="h6" fontWeight="light">
                                      {transaction.created}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default P2POrder;
